import { render, staticRenderFns } from "./Postscript.vue?vue&type=template&id=baba4fa0"
import script from "./Postscript.vue?vue&type=script&lang=ts"
export * from "./Postscript.vue?vue&type=script&lang=ts"
import style0 from "./postscript.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./preview.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports